module.exports = __webpack_public_path__ + "media/newstyle/images/hipercard-ec7a24248dd0d5ae42c4881e91a1d3db.svg";